import { useTheme } from '@mui/material/styles';

/**
 * The kit's entire visual skin, resolved from the app MUI theme. Every
 * FilterMenu component reads only these semantic tokens — restyling the
 * pattern (e.g. onto consoleTokens for analytics surfaces) means swapping
 * this one file, nothing structural.
 */
export interface FilterMenuTokens {
  ink: string;
  dim: string;
  faint: string;
  line: string;
  hoverBg: string;
  selectedBg: string;
  surfaceBg: string;
  shadow: string;
  radius: number;
  rowHeight: number;
  fontSize: string;
  metaFontSize: string;
  /** Base z-index for the root panel; the sub-panel renders at +1. */
  zIndex: number;
}

export const useFilterMenuTokens = (): FilterMenuTokens => {
  const theme = useTheme();
  return {
    ink: theme.palette.text.primary,
    dim: theme.palette.text.secondary,
    faint: theme.palette.text.disabled,
    line: theme.palette.divider,
    hoverBg: theme.palette.action.hover,
    selectedBg: theme.palette.action.selected,
    surfaceBg: theme.palette.background.paper,
    shadow: theme.shadows[8],
    radius: 8,
    rowHeight: 32,
    fontSize: '0.8125rem',
    metaFontSize: '0.75rem',
    zIndex: theme.zIndex.modal,
  };
};
